import { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import ErrorPage from '@/pages/error-boundary/ErrorPage';
import { ErrorBoundary } from '@/pages/error-boundary';
import { CustomThemeProvider } from '@/context/ThemeContext';
import Router from './routes';
const Toast = lazy(() => import('@/apps/core/Toast'));

const App = () => {
  return (
    <CustomThemeProvider>
      <ErrorBoundary fallback={<ErrorPage />}>
        <Suspense fallback={<>Loading...</>}>
          <BrowserRouter>
            <AuthProvider>
              <Router />
              <Toast />
            </AuthProvider>
          </BrowserRouter>
        </Suspense>
      </ErrorBoundary>
    </CustomThemeProvider>
  );
};

export default App;
